import { render, staticRenderFns } from "./ExistingPropertyShared.vue?vue&type=template&id=898085c4"
import script from "./ExistingPropertyShared.vue?vue&type=script&lang=js"
export * from "./ExistingPropertyShared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports